import React from 'react'

export interface ErrorAlertProps {
  error?: string | null
  title?: string
}

/**
 * ErrorAlert component - Displays general error messages from backend responses
 * Used for displaying 500 errors or other server-side errors
 */
const ErrorAlert: React.FC<ErrorAlertProps> = ({ error, title = 'Error' }) => {
  if (!error) {
    return null
  }

  return (
    <div className='bg-error/10 border border-error/30 rounded-lg p-4'>
      <div className='w-full'>
        <h3 className='font-semibold text-error text-base mb-2'>{title}</h3>
        <p className='text-sm text-error/90'>{error}</p>
      </div>
    </div>
  )
}

export default ErrorAlert
